import TableHeader from './TableHeader.vue';

export default TableHeader;
